import palette from 'constants/palette'
import React from 'react'

type Props = {
  className?: string
  strokeColor?: string
}

// Order-stage rail glyph: "on the way" (Live Updates Overview tab). Geometry is the
// Sketch prototype's own (live-updates-onboarding v31, `ICON2`), traced rather
// than approximated so the rail reads as one set.
const DeliveryTruck = ({ className, strokeColor = palette.grey90 }: Props) => (
  <svg
    className={className}
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
    <path d="M15 18H9" />
    <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
    <circle cx="7" cy="18" r="2" />
    <circle cx="17" cy="18" r="2" />
  </svg>
)

export default DeliveryTruck
